<template>
<section class="features2 cid-r5nFKMOCYf" id="features2-a">
    <div class="container">
        <div class="media-container-row">
            <h2>配图与正文无关</h2>
        </div>
        <div class="media-container-row">
            <Loading :active.sync="isLoading"></Loading>
        
            <div class="card p-3 col-12 col-md-6 col-lg-4" v-for="article in articles.slice(0,3)" :key="article.id">
                <ArticleBlockIndex v-bind:article='article' v-if="!isLoading"/>
            </div>
        </div>
        
        <div class="media-container-row">
            <div class="card p-3 col-12 col-md-6 col-lg-4" v-for="article in articles.slice(3,6)" :key="article.id">
                <ArticleBlockIndex v-bind:article='article' />
            </div>
        </div>
    </div>
</section>
</template>

<script>
import ArticleBlockIndex from "@/components/ArticleBlockIndex"
import Loading from 'vue-loading-overlay'

export default {
    name: "Articles",
    data: function () {
        return {
            articles: [],
            isLoading: true,
        }
    },
    methods: {
        getRandomArticles() {
            var uri="http://api.go4pro.org/go4pro/article/random/6";
            fetch(uri)
                .then(res => {
                    return res.json();
                })
                .then(json => {
                    this.articles=json;
                    this.isLoading=false;
                })
        }
    },
    created: function () {
        this.getRandomArticles();
    },
    components: {
        ArticleBlockIndex,
        Loading,
    },
    metaInfo() {
    return {
      title: "Go4Pro.org | 首页 | 随机文章",
      htmlAttrs: {
        lang: "zh-CN"
      },
      meta: [
        { name: "description", content: "随机文章，刷新页面后显示的文章会变"},
        { name: "keyword", content: "编程,文献,技术" }
      ]
    };
  }
}
</script>
